"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactSortableHoc = require("react-sortable-hoc");

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Icon = _interopRequireDefault(require("@material-ui/core/Icon"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _DragHandle = _interopRequireDefault(require("@material-ui/icons/DragHandle"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    padding: theme.spacing(1.5),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "grab"
  }
}));
const DraggableHandle = (0, _reactSortableHoc.sortableHandle)(({
  badgeContent,
  icon,
  className
}) => {
  const classes = useStyles();
  return _react.default.createElement("div", {
    className: className || classes.root,
    color: "inherit",
    "aria-label": "sort"
  }, _react.default.createElement(_Badge.default, {
    badgeContent: badgeContent,
    color: "primary"
  }, icon && _react.default.createElement(_Icon.default, null, icon) || _react.default.createElement(_DragHandle.default, null)));
});

const ButtonDraggable = ({
  className,
  sortBadge,
  draggableHandle,
  icon
}) => {
  const classes = useStyles();

  if (draggableHandle) {
    return _react.default.createElement(DraggableHandle, {
      className: className,
      icon: icon,
      badgeContent: sortBadge
    });
  }

  return _react.default.createElement(_IconButton.default, {
    className: className || classes.root,
    color: "inherit",
    "aria-label": "sort"
  }, icon && _react.default.createElement(_Icon.default, null, icon) || _react.default.createElement(_DragHandle.default, null));
};

var _default = ButtonDraggable;
exports.default = _default;
module.exports = exports.default;